import { authRequest } from './utils';

export const searchTasks = ({ searchTerm, page }) =>
  authRequest({
    method: 'GET',
    url: '/search',
    params: { page, searchTerm },
  }).then(({ data }) => data);
